// The ONE portal shortcut inventory. KeyboardHelp (the "?" dialog) renders it
// and the Help system's "Keyboard shortcuts" article is GENERATED from it —
// both surfaces read this array, so the reference can never drift from the
// dialog. useKeyboardShortcuts.ts is the behavior these rows describe; change
// a binding there and the row here in the same commit.
export type ShortcutGroup = {
  group: string;
  items: { keys: string[]; desc: string }[];
};

export const SHORTCUTS: ShortcutGroup[] = [
  {
    group: "General",
    items: [
      { keys: ["Ctrl", "K"], desc: "Open command palette" },
      { keys: ["/"], desc: "Focus global search" },
      { keys: ["?"], desc: "Show keyboard shortcuts" },
      { keys: ["Esc"], desc: "Close dialogs" },
    ],
  },
  {
    group: "Navigation",
    items: [
      { keys: ["g", "d"], desc: "Go to Dashboard" },
      { keys: ["g", "p"], desc: "Go to Projects" },
      { keys: ["g", "c"], desc: "Go to Calculations" },
      { keys: ["g", "o"], desc: "Go to Policies" },
      { keys: ["g", "m"], desc: "Go to Materials" },
      { keys: ["g", "u"], desc: "Go to Output & Docs" },
      { keys: ["g", "s"], desc: "Go to Settings" },
      { keys: ["g", "h"], desc: "Go to Help" },
      { keys: ["g", "n"], desc: "New Project" },
    ],
  },
  {
    group: "Command Palette",
    items: [
      { keys: ["↑", "↓"], desc: "Navigate results" },
      { keys: ["↵"], desc: "Select highlighted result" },
    ],
  },
];
